// @ts-nocheck
/**
 * timerDisplayRenderer.ts — Live countdown / stopwatch display (ticks in adapter).
 */

import { componentInteractionProps } from './interactionProps';
import { applyExpressionFallback, buildDescriptor, resolveValue } from './rendererUtils';
import type { CompiledPropsByType, ComponentRenderer } from './types';
import { extractTypedProps } from './types';

export const TIMER_DISPLAY_RENDERER: ComponentRenderer<CompiledPropsByType['timerDisplay']> = {
  supportedType: 'timerDisplay',
  render(context) {
    const issuesBefore = context.issues.length;
    const { visible, enabled } = applyExpressionFallback(context);
    const p = extractTypedProps('timerDisplay', context.node.props);

    const maxUnit = p.timerDisplay.maxUnit ?? 'hour';
    let timerId: string | null = null;
    if (p.timerDisplay.timerId != null) {
      const raw = resolveValue(p.timerDisplay.timerId, context);
      if (raw != null && String(raw).length > 0) {
        timerId = String(raw);
      }
    }

    const itemId = Number(context.bindingContext?.item?.id);
    return buildDescriptor(context.node, visible, enabled, {
      maxUnit,
      timerId,
      itemId: Number.isFinite(itemId) ? itemId : null,
      ...componentInteractionProps(context.node),
    }, {
      diagnostics: context.issues.slice(issuesBefore),
      renderContext: context,
    });
  },
};
